var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPlans(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.99928 18.9993V7.97428C5.99928 7.42428 6.19928 6.95761 6.59928 6.57428C6.99928 6.19095 7.47428 5.99928 8.02428 5.99928H18.9993C19.5493 5.99928 20.0201 6.19511 20.4118 6.58678C20.8034 6.97845 20.9993 7.44928 20.9993 7.99928V15.9993L15.9993 20.9993H7.99928C7.44928 20.9993 6.97845 20.8034 6.58678 20.4118C6.19511 20.0201 5.99928 19.5493 5.99928 18.9993ZM1.02428 5.24928C0.924281 4.69928 1.03261 4.20345 1.34928 3.76178C1.66595 3.32011 2.09928 3.04928 2.64928 2.94928L13.4993 1.02428C14.0493 0.924281 14.5451 1.03261 14.9868 1.34928C15.4284 1.66595 15.6993 2.09928 15.7993 2.64928L16.0493 3.99928H7.99928C6.89928 3.99928 5.95761 4.39095 5.17428 5.17428C4.39095 5.95761 3.99928 6.89928 3.99928 7.99928V17.5493C3.73261 17.3993 3.50345 17.1993 3.31178 16.9493C3.12011 16.6993 2.99928 16.4159 2.94928 16.0993L1.02428 5.24928ZM18.9993 14.9993H14.9993V18.9993L18.9993 14.9993Z",
    fill: "currentColor"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlans);
export default __webpack_public_path__ + "static/media/plans.2679a2bb85928703ee3d3f2c97d6a941.svg";
export { ForwardRef as ReactComponent };